export default import.meta.ROLLDOWN_FILE_URL_0PgJxXqjw$KAl6PgZjQb5g